import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateMeetingPrepTemplates, updateMeetingPrepTemplatesRQCache } from './useMeetingPrepTemplates';

/**
 * The server forces the per-user identity fields, so no creator, scope, or conversation type is sent.
 * A second create for the same user returns 409, which callers should treat as "reload and retry"
 * rather than an error to surface raw.
 */
export function useCreateMeetingPrepTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (template: Api.MeetingPrepTemplate) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (template: Omit<Api.MeetingPrepTemplate, 'id'>) => {
			return userSession.webServiceHelper.callAsync<Api.MeetingPrepTemplate>('meetingPrep/templates', 'POST', template);
		},
		onError,
		onSuccess: template => {
			updateMeetingPrepTemplatesRQCache(template);
			onSuccess?.(template);
		},
		onSettled: () => {
			invalidateMeetingPrepTemplates();
		},
	});
}
